<figure>
  <figcaption>Listen to {{ audioTitle }}</figcaption>
  <audio controls [src]="audioUrl"></audio>
</figure>
